module.exports = __webpack_public_path__ + "static/media/infoImage.8281b18c.jpg";